import { render, staticRenderFns } from "./DlgInputDescription.vue?vue&type=template&id=2f31c1ae&scoped=true&lang=html&"
import script from "./DlgInputDescription.vue?vue&type=script&lang=js&"
export * from "./DlgInputDescription.vue?vue&type=script&lang=js&"
import style0 from "./DlgInputDescription.vue?vue&type=style&index=0&id=2f31c1ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f31c1ae",
  null
  
)

export default component.exports